export default __webpack_public_path__ + "static/media/fishing_game_banner.7330565e.png";